module.exports = __webpack_public_path__ + "static/media/street1.73a3858a.jpg";